import { getIsInternalView } from '../../../shared/helpers/auth';
import { getHomePathFromHost } from '../../lib/home';
import { isAllowedHost } from '../../lib/hostname-utils';

// Re-export for backward compatibility
export { isAllowedHost } from '../../lib/hostname-utils';

export function defaultHeaders(
  token: string,
  organizationId: string | null,
): HeadersInit {
  if (organizationId === null) {
    throw new Error('Organization ID must not be null');
  }

  const isInternalView = getIsInternalView();

  return {
    Authorization: `Bearer ${token}`,
    'X-Organization-ID': organizationId,
    'X-Internal-View': isInternalView.toString(),
  };
}
export function redirectURLOrProjects(
  encodedLoginRedirect: string | null,
  host: string,
): string {
  const homePath = getHomePathFromHost(host);

  if (encodedLoginRedirect === null) {
    return homePath;
  }

  const loginRedirect = decodeURIComponent(encodedLoginRedirect);

  // Only validate full URLs to prevent open redirects. Relative paths
  // (e.g. /projects/123) are safe since they stay on the same origin.
  // The iframe login flow converts relative paths to full URLs upstream.
  if (
    process.env.NODE_ENV === 'production' &&
    (loginRedirect.startsWith('http://') ||
      loginRedirect.startsWith('https://'))
  ) {
    try {
      const url = new URL(loginRedirect);

      if (!isAllowedHost(url.hostname)) {
        return homePath;
      }
    } catch (error) {
      console.error('Failed to validate login redirect URL:', error);
      return homePath;
    }
  }

  return loginRedirect;
}
